/// <amd-module name="TFS/Admin/Groups/Pivots/Members/Redux/MembersPivotActions" />
import { ActionsUnion, createAction } from "redux/Utils/ActionHelper";
import { IPermissionPage, SearchStatus } from "TFS/Admin/Groups/Common/Constants";
import { CustomGraphMember, MembersOperation } from "TFS/Admin/Groups/Common/Contracts";
import { MessageCardSeverity } from "VSSUI/MessageCard";

/**
 * Actions for Users view
 */
export const MembersPivotActions = {
    initView: (scopeDescriptor?: string, permissionPage?: IPermissionPage) =>
        createAction(MembersPivotActionTypes.InitView, { scopeDescriptor, permissionPage }),
    disposeView: () => createAction(MembersPivotActionTypes.DisposeView),
    initialMembersLoadSucceeded: (members: CustomGraphMember[], continuationToken?: string[]) =>
        createAction(MembersPivotActionTypes.InitialMembersLoadSucceeded, { members, continuationToken }),
    membersLoadFailed: () => createAction(MembersPivotActionTypes.MembersLoadFailed),
    fetchMoreMembersSucceeded: (members: CustomGraphMember[], continuationToken?: string[]) =>
        createAction(MembersPivotActionTypes.FetchMoreMembersSucceeded, { members, continuationToken }),
    onRenderMissingItem: (continuationToken?: string[], scopeDescriptor?: string, permissionPage?: IPermissionPage) =>
        createAction(MembersPivotActionTypes.OnRenderMissingItem, { continuationToken, scopeDescriptor, permissionPage }),
    memberOperationStatus: (operation: MembersOperation, resultMessage: string, severity: MessageCardSeverity) =>
        createAction(MembersPivotActionTypes.MemberOperationStatus, { operation, resultMessage, severity }),
    onDismissMessageCard: () => createAction(MembersPivotActionTypes.DismissMessageCard),

    // Search
    searchMembers: (
        newKeyword?: string,
        oldKeyword?: string,
        scopeDescriptor?: string,
        isExpandSearchToOrg?: boolean,
        permissionPage?: IPermissionPage
    ) => createAction(MembersPivotActionTypes.SearchMembers, { newKeyword, oldKeyword, scopeDescriptor, isExpandSearchToOrg, permissionPage }),
    updateSearchStatus: (searchStatus: SearchStatus) => createAction(MembersPivotActionTypes.UpdateSearchStatus, searchStatus),
    updateSearchResult: (keyword: string, result: any[], hasMore: boolean) =>
        createAction(MembersPivotActionTypes.UpdateSearchResult, { result, hasMore, keyword })
};

export const enum MembersPivotActionTypes {
    InitView = "MembersPivot/Init",
    DisposeView = "MembersPivot/Dispose",
    InitialMembersLoadSucceeded = "MembersPivot/InitialMembersLoadSucceeded",
    MembersLoadFailed = "MembersPivot/MembersLoadFailed",
    FetchMoreMembersSucceeded = "MembersPivot/FetchMoreMembersSucceeded",
    OnRenderMissingItem = "MembersPivot/OnRenderMissingItem",
    MemberOperationStatus = "MembersPivot/MemberOperationStatus",
    DismissMessageCard = "MembersPivot/DismissMessageCard",

    // Search
    SearchMembers = "MembersPivot/SearchMembers",
    UpdateSearchStatus = "MembersPivot/UpdateSearchStatus",
    UpdateSearchResult = "MembersPivot/UpdateSearchResult"
}

export type MembersPivotActions = ActionsUnion<typeof MembersPivotActions>;
